"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCalculatorData = loadCalculatorData;
const schema_1 = require("@kalkulacka-one/schema");
const errors_1 = require("../errors/index.js");
const utilities_1 = require("../utilities/index.js");
const fetch_file_1 = require("./fetch-file");
const load_election_1 = require("./load-election");
const url_builders_1 = require("./url-builders");
const DATA_CONFIG = {
    calculator: {
        filename: "calculator.json",
        schema: schema_1.calculatorSchema,
        required: true,
    },
    questions: {
        filename: "questions.json",
        schema: schema_1.questionsSchema,
        required: true,
    },
    candidates: {
        filename: "candidates.json",
        schema: schema_1.candidatesSchema,
        required: true,
    },
    candidatesAnswers: {
        filename: "candidates-answers.json",
        schema: schema_1.candidatesAnswers,
        required: true,
    },
    persons: {
        filename: "persons.json",
        schema: schema_1.personsSchema,
    },
    organizations: {
        filename: "organizations.json",
        schema: schema_1.organizationsSchema,
    },
};
async function loadElectionIfPossible({ endpoint, group }) {
    try {
        return await (0, load_election_1.loadElection)({ endpoint, group });
    }
    catch (error) {
        if (!(error instanceof errors_1.NotFoundError))
            console.error(`Election of \`${group}\` could not be loaded; the calculator runs without rounds`, error);
        return undefined;
    }
}
async function loadCalculatorData({ endpoint, key, group }) {
    const fileEntries = Object.entries(DATA_CONFIG).map(([entryKey, config]) => ({
        key: entryKey,
        url: (0, url_builders_1.buildDataUrl)({ endpoint, key, group, resourcePath: config.filename }),
        schema: config.schema,
        required: "required" in config && config.required,
    }));
    const fetchPromises = fileEntries.map(({ url, required }) => (0, fetch_file_1.fetchFile)({ url }).catch((error) => {
        if (required) {
            throw error;
        }
        return undefined;
    }));
    const results = await Promise.all(fetchPromises);
    const parsedData = fileEntries
        .map(({ key, schema }, index) => {
        const data = results[index];
        if (data === undefined)
            return undefined;
        try {
            return [key, (0, utilities_1.parseWithSchema)({ data, schema: schema })];
        }
        catch (error) {
            throw new Error(`Failed to parse ${key} data: ${error.message}`);
        }
    })
        .filter((entry) => entry !== undefined);
    const data = Object.fromEntries(parsedData);
    if (group && "election" in data.calculator) {
        data.rounds = (await loadElectionIfPossible({ endpoint, group }))?.rounds;
    }
    return { data, key, group, baseUrl: (0, url_builders_1.buildDataUrl)({ endpoint, key, group }) };
}
